<template>
  <div class="sidebar-chat">
    <div
      class="chat-messages"
      ref="messages"
    >
      <CommentItem
        v-for="(c, i) in chatMessages"
        :key="i"
        :message="c"
      />
    </div>
    <div class="chat-input">
      <v-text-field
        color="blue"
        filled
        dense
        hide-details
        v-model.trim="message"
        placeholder="Type your message..."
        @keyup.enter="send"
        @click:append="send"
        append-icon="mdi-send"
      ></v-text-field>
    </div>
  </div>
</template>

<script>
import CommentItem from "./chat/CommentItem.vue"
export default {
  name: "SideBarChat",
  components: {
    CommentItem
  },
  props: {
    inspection: {
      type: Object,
      default: null
    }
  },
  computed: {
    chatConversation() {
      return this.$store.state.meeting.chatConversation
    },
    chatMessages() {
      return this.$store.state.meeting.chatMessages
    }
  },
  data() {
    return {
      message: ""
    }
  },
  methods: {
    send() {
      const $ = this
      if ($.message && $.chatConversation) {
        $.chatConversation.sendMessage($.message).then(() => {
          $.$nextTick(() => {
            $.$refs.messages.scrollTop = $.$refs.messages.scrollHeight
            $.message = ""
          })
        })
      }
    }
  }
}
</script>

<style lang="scss">
.sidebar-chat {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-height: 100%;

  .chat-input {
    flex: 0 1 auto;
    margin-top: 16px;
  }
  .chat-messages {
    flex: 1 1 auto;
    overflow: auto;
  }
}
</style>
